import { IChanges } from './../IChanges';
import { Module } from './module';

export class ModuleCard extends Module implements IChanges {
  public constructor(init?: Partial<ModuleCard>) {
    super();
    Object.assign(this, init);
  }

  get BaseVersionText(): string {
    if (this.MajorBaseVersion === undefined || this.MajorBaseVersion === 0) {
      return '';
    }

    if (this.MinorBaseVersion === undefined || this.MinorBaseVersion === 0) {
      return `v${this.MajorBaseVersion}`;
    }

    return `v${this.MajorBaseVersion}.${this.MinorBaseVersion}`;
  }

  // IChanges
  Loading?: boolean;
  HasError?: boolean;
  IsPartiallySynced?: boolean;
  IsFullySynced?: boolean;
  HasChanges?: string;
  Changes?: boolean;
  LatestServerVersion?: number;
  IsLatestServerVersion?: boolean;
}
